import {
  GET_USER_SUCCESS,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE
} from '../../actions/api/user';
import {
  PROFILE_INITIALIZE,
  PROFILE_INPUT_CHANGE,
  PROFILE_ADMIN_CHANGE
} from '../../actions/page/Profile';

import {
  DELETE_PHONE_SUCCESS,
  DELETE_PHONE_FAILURE
} from '../../actions/api/phone';

export default function Profile(state = {}, action) {
  switch (action.type) {
    case PROFILE_INITIALIZE:
      const defaults = {
        loading: true,
        saving: false,
        success: true,
        userID: null,
        isTeamAdmin: false,
        username: '',
        email: '',
        phone: '',
        fullName: '',
        password: '',
        passwordConfirm: '',
        deletePhoneSuccess: false
      };
      return {
        ...state,
        ...defaults
      };
    case PROFILE_INPUT_CHANGE:
      return {
        ...state,
        [action.field]: action.newData
      };
    case PROFILE_ADMIN_CHANGE:
      return {
        ...state,
        isTeamAdmin: action.isTeamAdmin
      };
    case GET_USER_SUCCESS:
      const user = action.response.entities.users[action.response.result];
      let notificationPreference = true; // eslint-disable-line no-unused-vars
      try {
        notificationPreference = user.notificationPreference.email.enabled;
      } catch (e) {
        /* this space intentionally blank */
      }
      return {
        ...state,
        loading: false,
        userID: action.response.result,
        email: user.email,
        fullName: user.fullName,
        username: user.username,
        isTeamAdmin: user.isTeamAdmin || user.isTeamOwner || false,
        phone: user.phone
      };
    case UPDATE_USER_REQUEST:
      return {
        ...state,
        saving: true
      };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        saving: false,
        success: true,
        password: '',
        passwordConfirm: ''
      };
    case UPDATE_USER_FAILURE:
      return {
        ...state,
        saving: false,
        success: false
      };
    case DELETE_PHONE_SUCCESS:
      return {
        ...state,
        deletePhoneSuccess: true,
        phone: ''
      };
    case DELETE_PHONE_FAILURE:
      return {
        ...state,
        deletePhoneSuccess: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/page/Profile.js